import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=23787973&scoped=true&"
import script from "./Classes.vue?vue&type=script&lang=js&"
export * from "./Classes.vue?vue&type=script&lang=js&"
import style0 from "./Classes.vue?vue&type=style&index=0&id=23787973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23787973",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23787973')) {
      api.createRecord('23787973', component.options)
    } else {
      api.reload('23787973', component.options)
    }
    module.hot.accept("./Classes.vue?vue&type=template&id=23787973&scoped=true&", function () {
      api.rerender('23787973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classes/Classes.vue"
export default component.exports